// /images 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 6개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값 동일.
// name 검색은 기존과 동일하게 operator "eq" 유지.

import type { SearchFieldConfig } from "components/list";

export const imagesSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "name", label: "이름", type: "text", operator: "eq", width: 220 },
  {
    name: "extension",
    label: "확장자",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "JPG", label: "JPG" },
      { value: "JPEG", label: "JPEG" },
      { value: "PNG", label: "PNG" },
      { value: "WEBP", label: "WEBP" },
    ],
  },
  {
    name: "category",
    label: "종류",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "USER", label: "USER" },
      { value: "CHILD", label: "CHILD" },
      { value: "CENTER", label: "CENTER" },
      { value: "BOARD", label: "BOARD" },
      { value: "POST", label: "POST" },
      { value: "PRESENTATION", label: "PRESENTATION" },
    ],
  },
  { name: "targetId", label: "연관Entity ID", type: "text", operator: "contains", width: 200 },
  {
    name: "uploadStatus",
    label: "업로드상태",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "NONE", label: "NONE" },
      { value: "PENDING", label: "PENDING" },
      { value: "COMPLETE", label: "COMPLETE" },
    ],
  },
];
